import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=cf55992c"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports